// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","heroImg":"Hero_heroImg__zb5aB","overlay":"Hero_overlay__ojFeQ","content":"Hero_content__YK9OZ","info":"Hero_info__HKZhn"};